// extracted by mini-css-extract-plugin
export var attribution = "_cf-4";
export var authorName = "_cf-5";
export var quote = "_cf-3";
export var testimonial = "_cf-2";
export var trustedBy = "_cf-0";
export var trustedByLabel = "_cf-1";